import { handleInventory, handleInventoryBatch, handleInventoryBatches, handleListingsDetails, handleListings } from '../helpers/routes'

export default [
  {
    path: '/inventory',
    name: 'Inventory',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Inventory/index.vue'),
    beforeEnter: handleInventory
  },
  {
    path: '/inventory/views',
    name: 'InventoryViews',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Inventory/Views.vue'),
  },
  {
    path: '/inventory/views/:viewId',
    name: 'InventoryViewDetails',
    component: () => import('@/views/Inventory/index.vue'),
    meta: { requireAuth: true, requireFields: true },
    beforeEnter: handleInventory,
  },
  {
    // All batches, inside Inventory (new-design only). Must precede any
    // /inventory/:param route, or "batches" gets read as a card id.
    path: '/inventory/batches',
    name: 'InventoryBatches',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/InventoryBatches/index.vue'),
    beforeEnter: handleInventoryBatches,
  },
  {
    // Batch-in-inventory (new-design only). Placed before /inventory/:cardId so
    // the two-segment path is unambiguous; guarded by new_design. Children mirror
    // the batch route nesting: they all point to the same InventoryBatch component
    // (which has no <router-view>), so the parent stays mounted while :cardId/:tab
    // params + route.name update — the Inspector's card-to-card navigation.
    path: '/inventory/batch/:batchId',
    component: () => import('@/views/InventoryBatch/index.vue'),
    meta: { requireAuth: true, requireFields: true },
    beforeEnter: handleInventoryBatch,
    children: [
      { path: '', name: 'InventoryBatch', component: () => import('@/views/InventoryBatch/index.vue') },
      {
        path: 'inspector',
        component: () => import('@/views/InventoryBatch/index.vue'),
        children: [
          { path: '', name: 'InventoryBatchInspector', component: () => import('@/views/InventoryBatch/index.vue') },
          { path: ':cardId', name: 'InventoryBatchInspectorCard', component: () => import('@/views/InventoryBatch/index.vue') },
        ],
      },
      {
        path: ':cardId',
        component: () => import('@/views/InventoryBatch/index.vue'),
        children: [
          { path: '', name: 'InventoryBatchByCard', component: () => import('@/views/InventoryBatch/index.vue') },
          { path: ':tab', name: 'InventoryBatchByCardTab', component: () => import('@/views/InventoryBatch/index.vue') },
        ],
      },
    ],
  },
  {
    path: '/inventory/:cardId',
    name: 'InventoryDetails',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/InventoryDetails/index.vue'),
  },
  {
    path: '/listings/:connection/:cardId',
    meta: { requireAuth: true, requireFields: true },
    name: 'ListingsDetails',
    component: () => import('@/views/ListingsDetails/index.vue'),
    sensitive: true,
    beforeEnter: handleListingsDetails,
  },
  {
    path: '/listings',
    name: 'Listings',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Listings/index.vue'),
    beforeEnter: handleListings,
    children: [
      {
        path: ':connection',
        component: () => import('@/views/Listings/ListingsByConnection.vue'),
        sensitive: true,
        name: 'ListingsByConnection',
      }
    ]
  }
]
